import script from "./ckeditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ckeditor.vue?vue&type=script&setup=true&lang=ts"

import "./ckeditor-style.scss?vue&type=style&index=0&lang=scss&external"
import "./ckeditor.vue?vue&type=style&index=1&id=b339ba8c&lang=scss"

const __exports__ = script;

export default __exports__